export const system = [
  {
    path: '/system',
    name: 'system',
    component: () => import('@/views/Layout/index.vue'),
    children: [
      {
        path: 'vat',
        name: 'vat',

        component: () => import('@/views/Layout/system/index'),
        children: [
          {
            path: 'mine',
            meta: {
              title: '我的账户'
            },
            name: 'mine',
            component: () => import('@/views/Layout/system/mine')
          },
          {
            path: 'orderList',
            name: 'orderList',
            meta: {
              title: '订单列表'
            },
            component: () => import('@/views/order/orderList')
          },
          {
            path: 'searchList',
            name: 'searchList',
            meta: {
              title: '快速查询'
            },
            component: () => import('@/views/searchList/index')
          },
          {
            path: 'DeclarationRecord',
            name: 'DeclarationRecord',
            meta: {
              title: '当期申报'
            },
            component: () => import('@/views/DeclarationRecord/DeclarationRecord')
          },
          {
            path: 'CurrentDeclaration',
            name: 'CurrentDeclaration',
            meta: {
              title: '申报记录'
            },
            component: () => import('@/views/DeclarationRecord/CurrentDeclaration')
          },
          {
            path: 'taxNumber',
            name: 'taxNumber',
            meta: {
              title: '税号申请查询'
            },
            component: () => import('@/views/DeclarationRecord/taxNumber')
          },

          {
            path: 'WorkOrderList',
            name: 'WorkOrderList',
            meta: {
              title: '我的工单'
            },
            component: () => import('@/views/WorkOrder/WorkOrderList')
          },
          {
            path: 'letterList',
            name: 'letterList',
            meta: {
              title: '我的信件'
            },
            component: () => import('@/views/WorkOrder/letterList')
          }
        ]
      },
      {

        path: 'orderDetail',
        name: 'orderDetail',
        meta: {
          title: '订单详情'
        },
        component: () => import('@/views/order/orderDetail')
      },
      {
        path: 'couponList',
        name: 'couponList',
        meta: {
          title: '我的可用代金券'
        },
        component: () => import('@/views/couponList/index')
      },
      {

        path: 'paySure',
        name: 'paySure',
        meta: {
          title: '支付确认'
        },
        component: () => import('@/views/paySure/index')
      },
      {
        path: 'user',
        name: 'user',
        component: () => import('@/views/Layout/user/user'),
        children: [
          {
            path: 'login',
            name: 'login',
            component: () => import('@/views/Layout/user/login')
          },
          {
            path: 'loginLoading',
            name: 'loginLoading',
            component: () => import('@/views/Layout/user/loginLoading')
          },
          {
            path: 'loginList',
            name: 'loginList',
            component: () => import('@/views/Layout/user/loginList')
          },
          {
            path: 'loginBottom',
            name: 'loginBottom',
            component: () => import('@/views/Layout/user/loginBottom')
          },
          {
            path: 'pageLogin',
            name: 'loginTest',
            component: () => import('@/views/Layout/user/loginTest')
          },
          {
            path: 'forget',
            name: 'forget',
            component: () => import('@/views/Layout/user/forget')
          }
        ]
      }
    ]
  },
  // 申报记录
  {
    path: '/seeimg',
    name: 'seeimg',
    component: () => import('@/views/DeclarationRecord/seeimg')
  },
  // 错误短链接
  {
    path: '/errorUrl',
    name: 'errorUrl',
    component: () => import('@/views/ErrorUrl')
  }
]



// WEBPACK FOOTER //
// ./src/router/routerUtil.js